import type { SVGProps } from 'react';

interface WarningTickProps extends SVGProps<SVGSVGElement> {}

export const WarningTick = (props: WarningTickProps) => {
	return (
		<svg
			width="51"
			height="50"
			viewBox="0 0 51 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Warning Tick</title>
			<circle cx="25.5" cy="25" r="21.25" fill="#FCEDCB" />
			<circle cx="25.5" cy="24.9688" r="16.25" fill="#DCA81D" />
			<circle cx="26.75" cy="23.7188" r="15" fill="#F6C350" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M33.9372 18.2902C34.5474 18.9004 34.5474 19.8897 33.9372 20.4999L24.265 30.1718C23.6548 30.782 22.6655 30.782 22.0553 30.1718L18.1212 26.2378C17.511 25.6277 17.511 24.6383 18.1212 24.0281C18.7314 23.4179 19.7207 23.4179 20.3309 24.0281L23.1602 26.8573L31.7275 18.2902C32.3377 17.68 33.327 17.68 33.9372 18.2902Z"
				fill="#EAF5EE"
			/>
		</svg>
	);
};

export default WarningTick;
